import { isAxiosError } from 'axios';
import { EmissorResumo, NcmProfileItemDto, SituacaoRegra } from './types';

export const SITUACAO_LABEL: Record<SituacaoRegra, string> = {
  CONFIGURADA: 'Configurada',
  PARCIAL: 'Parcial',
  SEM_REGRA: 'Sem regra',
};

export const SITUACAO_TOM: Record<SituacaoRegra, 'ok' | 'warn' | 'bad'> = {
  CONFIGURADA: 'ok',
  PARCIAL: 'warn',
  SEM_REGRA: 'bad',
};

// A tela mostra "0,00"; o back normaliza vírgula, mas envia com ponto para não depender disso.
export const normalizeDecimal = (value: string): string => value.trim().replace(',', '.');

export const plural = (n: number, um: string, varios: string): string => `${n} ${n === 1 ? um : varios}`;

export const emissorLabel = (e: EmissorResumo): string => {
  const digits = (e.cnpj ?? '').replace(/\D/g, '');
  // O número do estabelecimento (4 dígitos após a raiz) separa filiais com a mesma razão social.
  const estabelecimento = digits.length >= 12 ? digits.substring(8, 12) : '';
  const tipo = estabelecimento ? (estabelecimento === '0001' ? 'Matriz' : `Filial ${estabelecimento}`) : '';
  const nome = e.companyName ?? String(e.companyId);
  return tipo ? `${tipo} · ${nome}` : nome;
};

export const usoTotal = (i: NcmProfileItemDto): number =>
  i.usos.produtos + i.usos.resources + i.usos.estoques + i.usos.orderItems;

export const usoPartes = (i: NcmProfileItemDto): string[] =>
  [
    i.usos.produtos ? plural(i.usos.produtos, 'produto', 'produtos') : '',
    i.usos.resources ? plural(i.usos.resources, 'insumo', 'insumos') : '',
    i.usos.estoques ? `${i.usos.estoques} em estoque` : '',
    i.usos.orderItems ? `${plural(i.usos.orderItems, 'item', 'itens')} de pedido` : '',
  ].filter((p) => p !== '');

export const extractErrorMessage = (error: unknown, fallback: string): string => {
  if (isAxiosError<{ message?: string | string[] }>(error)) {
    const msg = error.response?.data?.message;
    if (Array.isArray(msg)) return msg.join(', ');
    if (typeof msg === 'string') return msg;
  }
  return fallback;
};
